"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateGasLimit = exports.inferMaxFeePerGas = exports.inferMaxPriorityFeePerGas = exports.inferGasPrice = exports.getNetworkInfo = void 0;
const live_env_1 = require("@ledgerhq/live-env");
const cache_1 = require("@ledgerhq/live-network/cache");
const api_1 = require("./api");
const transaction_1 = require("./transaction");
const range_1 = require("../../range");
const getNetworkInfo = (currency) => __awaiter(void 0, void 0, void 0, function* () {
    const api = (0, api_1.apiForCurrency)(currency);
    const { low, medium, high, next_base } = yield api.getGasTrackerBarometer(currency);
    const minValue = low;
    const maxValue = high.lte(low) ? low.times(2) : high;
    const initial = medium;
    if ((0, transaction_1.EIP1559ShouldBeUsed)(currency)) {
        const maxPriorityFeePerGas = (0, range_1.inferDynamicRange)(initial, {
            minValue,
            maxValue,
        });
        const nextBaseFeePerGas = next_base;
        return {
            family: "ethereum",
            maxPriorityFeePerGas,
            nextBaseFeePerGas,
        };
    }
    const gasPrice = (0, range_1.inferDynamicRange)(initial, {
        minValue,
        maxValue,
    });
    return {
        family: "ethereum",
        gasPrice,
    };
});
exports.getNetworkInfo = getNetworkInfo;
const inferGasPrice = (tx, networkInfo) => {
    var _a, _b, _c, _d;
    return tx.feesStrategy === "slow"
        ? (_a = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.gasPrice) === null || _a === void 0 ? void 0 : _a.min
        : tx.feesStrategy === "medium"
            ? (_b = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.gasPrice) === null || _b === void 0 ? void 0 : _b.initial
            : tx.feesStrategy === "fast"
                ? (_c = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.gasPrice) === null || _c === void 0 ? void 0 : _c.max
                : tx.gasPrice || ((_d = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.gasPrice) === null || _d === void 0 ? void 0 : _d.initial);
};
exports.inferGasPrice = inferGasPrice;
const inferMaxPriorityFeePerGas = (tx, networkInfo) => {
    var _a, _b, _c, _d;
    if (networkInfo.maxPriorityFeePerGas)
        return tx.feesStrategy === "slow"
            ? (_a = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.maxPriorityFeePerGas) === null || _a === void 0 ? void 0 : _a.min
            : tx.feesStrategy === "medium"
                ? (_b = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.maxPriorityFeePerGas) === null || _b === void 0 ? void 0 : _b.initial
                : tx.feesStrategy === "fast"
                    ? (_c = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.maxPriorityFeePerGas) === null || _c === void 0 ? void 0 : _c.max
                    : tx.maxPriorityFeePerGas || ((_d = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.maxPriorityFeePerGas) === null || _d === void 0 ? void 0 : _d.initial);
};
exports.inferMaxPriorityFeePerGas = inferMaxPriorityFeePerGas;
const inferMaxFeePerGas = (tx, priorityFeePerGas, networkInfo) => {
    var _a;
    if (tx.maxFeePerGas)
        return tx.maxFeePerGas;
    const amplifiedBaseFee = (_a = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.nextBaseFeePerGas) === null || _a === void 0 ? void 0 : _a.multipliedBy((0, live_env_1.getEnv)("EIP1559_BASE_FEE_MULTIPLIER")).integerValue();
    return amplifiedBaseFee === null || amplifiedBaseFee === void 0 ? void 0 : amplifiedBaseFee.plus(priorityFeePerGas || 0);
};
exports.inferMaxFeePerGas = inferMaxFeePerGas;
exports.estimateGasLimit = (0, cache_1.makeLRUCache)((account, transaction) => {
    const api = (0, api_1.apiForCurrency)(account.currency);
    return api
        .getDryRunGasLimit(transaction)
        .then(value => value.eq(21000) // regular ETH send should not be amplified
        ? value
        : value.times((0, live_env_1.getEnv)("ETHEREUM_GAS_LIMIT_AMPLIFIER")).integerValue())
        .catch(() => api.getFallbackGasLimit(transaction.to));
}, (account, { from, to, value, data }) => `${from}+${to}+${value}+${data}`);
exports.default = {
    getNetworkInfo: exports.getNetworkInfo,
    inferGasPrice: exports.inferGasPrice,
    inferMaxFeePerGas: exports.inferMaxFeePerGas,
    inferMaxPriorityFeePerGas: exports.inferMaxPriorityFeePerGas,
};
//# sourceMappingURL=gas.js.map